// Parâmetros de impostos enviados a cada rodagem do motor de DRE. Espelha o
// modelo do aawz-web-interno (controladoria_v2/constants/taxParams.js): o
// backend persiste os valores em partners_financial_parametrizacao_escritorio_v2
// e os devolve no status (`parametros_impostos`) para pré-seleção na próxima
// rodagem.
export const DEFAULT_TAX_PARAMS = {
  provisao_impostos_automatica: true,
  possui_simples_nacional: false,
}

// Labels exibidos nos checkboxes do modal de confirmação (mesmo texto do interno).
export const TAX_PARAMS_LABELS = {
  provisao_impostos_automatica:
    'Provisão de impostos automática (com base na receita)',
  possui_simples_nacional: 'Possui regime tributário Simples Nacional na PJ2',
}
